import { Component, Input, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PATH } from '@app/constants';
import SwiperCore, { Autoplay, EffectCards, EffectFade, Navigation, Pagination, SwiperOptions } from 'swiper';
import { SwiperComponent, SwiperModule } from 'swiper/angular';

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, EffectCards ]);

@Component({
  selector: 'mnf-dashboard-v2-banner',
  standalone: true,
  imports: [RouterModule, SwiperModule],
  templateUrl: './dashboard-v2-banner.component.html',
  styleUrl: './dashboard-v2-banner.component.scss'
})

export class DashboardV2BannerComponent {
  @ViewChild('swiper') swiper!: SwiperComponent;
  @Input() userWithDomiciliation: boolean;
  @Input() userWithAutoGrowth: boolean;
  path = PATH;
  domiciUser: any;
  showBanner = true;
  showSwiper: boolean = true;

  swiperConfig: SwiperOptions = {
    effect: 'slide',
    loop: false,
    pagination: true,
    speed: 1000,
    navigation: false,
    autoplay: {
      delay: 10000,
      pauseOnMouseEnter: true,
      waitForTransition: true,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  }
}